import { status } from '@/alas';
import { defineComponent, ref, onMounted, computed, watch } from '@vue/composition-api';
export default defineComponent({
    props: ['mode', 'cycle'],
    setup(props) {
        // ================
        //
        // refs
        //
        let types = ref(status.fetch('types'));
        // ================
        //
        // watch
        //
        watch(() => props.cycle.type, () => {
            props.cycle.breed = null;
        });
        // ================
        //
        // computed
        //
        let warn = computed(() => {
            if (props.cycle.breed == null) {
                return null;
            }
            let type = types.value.fetch(props.cycle.type);
            if (type) {
                let breed = type.breeds.fetch(props.cycle.breed);
                return breed ? breed.warn : '';
            }
            return '';
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            types.value.o.fetch.seek();
        });
        // ================
        //
        // done
        //
        return {
            warn,
            types
        };
    }
});
